import { useAppSelector } from "../store/index.ts";

export default function useBalance() {
  const balance = useAppSelector((state) => state.user.balance);
  const currency = useAppSelector((state) => state.user.currency);

  const getMainBalance = (currency) => {
    const mainBalance = balance[currency]?.balances?.main;
    const decimal = balance[currency]?.info?.decimal || 0;
    return +mainBalance?.toFixed(decimal) || 0;
  };

  const getBonusBalance = (currency) => {
    const bonusBalance = balance[currency]?.balances?.bonus;
    const decimal = balance[currency]?.info?.decimal || 0;

    return +bonusBalance?.toFixed(decimal) || 0;
  };

  const mainBalance = getMainBalance(currency);
  const bonusBalance = getBonusBalance(currency);

  return {
    mainBalance,
    bonusBalance,
    getMainBalance,
    getBonusBalance
  };
}
